import type { TranslationKeys } from './en';
const itBase: TranslationKeys = {
    // ── Comune ──
    app_name: 'Seeday',
    confirm: 'Conferma',
    cancel: 'Annulla',
    save: 'Salva',
    delete: 'Elimina',
    retry: 'Riprova',
    expand: 'Espandi',
    close: 'Chiudi',
    notification_action_confirm: '✓ Conferma',
    notification_action_deny: 'Sto facendo altro',
    notification_action_view_report: 'Vedi diario',
    notification_action_grow_plant: 'Coltiva pianta',
    notification_action_weekend_confirm: 'Segna ora',
    notification_action_weekend_deny: 'Ignora',
    notification_action_open_chat: 'Apri chat',
    notification_action_still_yes: '✓ Sto ancora facendo',
    notification_action_still_no: 'Sto facendo altro',
    loading: 'Caricamento…',
    app_loading_wait: 'Caricamento in corso, attendi un momento...',
    no_data: 'Nessun dato disponibile',
    // ── Formattazione durata ──
    duration_hours_minutes: '{{hours}}h {{mins}}m',
    duration_minutes: '{{mins}}m',
    duration_label: 'Durata {{duration}}',
    elapsed_label: 'Trascorso {{duration}}',
    // ── Intestazione ──
    header_login: 'Accedi / Registrati',
    header_confirm_logout: 'Sei sicuro di voler uscire?',
    // ── Navigazione inferiore ──
    nav_record: 'Registro',
    nav_report: 'Rapporto',
    nav_profile: 'Profilo',
    // ── Chat / Pagina Registro ──
    chat_title: 'Registro',
    chat_history_readonly: 'Visualizzando una data passata — torna a oggi per aggiungere record',
    chat_ongoing: 'In corso',
    chat_current_activity: 'In corso: ',
    chat_date_section_hint: 'Il tempo visto oggi',
    chat_placeholder_mood: 'Registra il tuo umore (es. entusiasta)… Tocca ❤️ per passare alle attività',
    chat_placeholder_activity: 'Registra la tua attività (es. pranzo)… Tocca ❤️ per passare all\'umore',
    chat_placeholder_neutral: 'Scrivi questo momento, l\'albero lo ricorderà',
    chat_historical_read_only: 'Le date passate sono di sola lettura',
    chat_switch_to_activity: 'Passa alla modalità attività',
    chat_switch_to_mood: 'Passa alla modalità umore',
    chat_confirm_delete: 'Sei sicuro di voler eliminare questo record?',
    chat_edit_record: 'Modifica Record',
    chat_insert_record: 'Inserisci Record',
    chat_label_content: 'Contenuto',
    chat_placeholder_content: 'Cosa hai fatto…',
    chat_label_start_time: 'Ora di inizio',
    chat_start_time_no_future: 'L\'ora di inizio non puo essere nel futuro',
    chat_label_end_time: 'Ora di fine',
    chat_title_edit: 'Modifica',
    chat_title_insert: 'Inserisci dopo',
    chat_title_delete: 'Elimina',
    chat_load_more_records: 'Caricamento di altri record…',
    chat_reached_oldest: '— Hai raggiunto il record piu vecchio —',
    chat_custom_label_default: 'Personalizzato',
    chat_unknown_mood_label: 'Non classificato',
    chat_pick_mood_for_record: 'Scegli l\'umore per questo record',
    chat_mood_note_label: 'Nota sull\'umore',
    chat_mood_note_placeholder: 'Scrivi come ti sentivi durante questa attivita…',
    chat_adjust_mood_label: 'Modifica etichetta umore',
    chat_duration_logged: 'Hai lasciato {{minutes}} min',
    chat_end_activity: 'Fine',
    chat_convert_to_activity: 'Converti in attività',
    chat_convert_to_mood: 'Converti in umore',
    chat_magic_pen_open: 'Penna magica',
    chat_magic_pen_title: 'Penna magica',
    chat_magic_pen_subtitle: 'Recupera attività perse o estrai to-do da una nota',
    chat_magic_pen_confirm: 'Scrivi tutto',
    chat_magic_pen_mode_on: 'Modalita Penna magica attiva',
    chat_magic_pen_mode_off: 'Modalita Penna magica disattiva',
    chat_magic_pen_retry_failed: 'Riprova falliti',
    chat_magic_pen_cancel: 'Annulla',
    chat_magic_pen_group_activity: 'Recupero attività',
    chat_magic_pen_group_todo: 'Nuovi to-do',
    chat_magic_pen_group_unparsed: 'Non riconosciuto',
    chat_magic_pen_group_auto_written: 'Scritti automaticamente',
    chat_magic_pen_auto_written_badge: 'Scritto automaticamente',
    chat_magic_pen_undo_auto_written: 'Annulla',
    chat_magic_pen_linked_mood_label: 'Umore collegato',
    chat_magic_pen_unparsed_hint: 'Questi elementi non sono stati riconosciuti automaticamente. Puoi aggiungerli dall\'input principale.',
    chat_magic_pen_missing_time: 'Ora di inizio e fine obbligatorie',
    chat_magic_pen_estimated_time: 'Orario stimato - conferma',
    chat_magic_pen_invalid_time: 'Intervallo orario non valido',
    chat_magic_pen_future_time: 'L\'ora di fine non puo essere nel futuro',
    chat_magic_pen_cross_day: 'Inizio e fine devono essere nello stesso giorno',
    chat_magic_pen_overlap: 'Orario in sovrapposizione con un altro elemento',
    chat_magic_pen_overlap_ongoing: 'Orario in conflitto con un\'attivita in corso',
    chat_magic_pen_overlap_hint: 'In conflitto con "{{activity}}" - modifica l\'orario',
    chat_magic_pen_partial_success: 'Alcuni elementi non sono stati salvati, puoi riprovare',
    chat_magic_pen_ai_error: 'Analisi non riuscita, riprova',
    chat_magic_pen_success_summary: 'Recuperate {{activityCount}} attività, aggiunti {{todoCount}} to-do',
    chat_magic_pen_item_success: 'Salvato',
    chat_magic_pen_item_error: 'Salvataggio fallito',
    chat_magic_pen_upgrade_title: 'Penna magica e una funzione Pro',
    chat_magic_pen_upgrade_desc: 'Passa a Pro per usare la Penna magica e trasformare una frase in attività e to-do.',
    chat_magic_pen_upgrade_cta: 'Passa a Pro',
    chat_magic_pen_upgrade_later: 'Forse dopo',
    // ── Pagina Attività ──
    todo_title: 'Attività',
    todo_filter_daily: 'Oggi',
    todo_filter_weekly: 'Questa settimana',
    todo_filter_monthly: 'Questo mese',
    todo_empty: 'Nessuna attività',
    todo_add: 'Aggiungi attività',
    todo_edit: 'Modifica attività',
    todo_label_content: 'Contenuto',
    todo_placeholder_content: 'Cosa fare…',
    todo_label_priority: 'Priorità',
    todo_label_recurrence: 'Ripetizione',
    todo_label_category: 'Categoria',
    todo_placeholder_custom_category: 'Personalizzato…',
    todo_delete_confirm: 'Elimina questa attività',
    todo_delete_recurring_title: 'Questo è un compito ricorrente',
    todo_delete_recurring_desc: 'Scegli come eliminare',
    todo_delete_today_only: 'Solo oggi',
    todo_delete_all_future: 'Elimina tutti i futuri',
    todo_duration: 'Durata {{minutes}} min',
    todo_pin: 'Fissa in alto',
    todo_unpin: 'Rimuovi',
    todo_start: 'Avvia timer',
    todo_in_progress: 'In corso',
    // Etichette priorità
    priority_urgent_important: 'Urgente e Importante',
    priority_important_not_urgent: 'Importante, Non Urgente',
    priority_urgent_not_important: 'Urgente, Non Importante',
    priority_not_important_not_urgent: 'Non Importante, Non Urgente',
    // Etichette ricorrenza
    recurrence_none: 'Nessuna ripetizione',
    recurrence_daily: 'Ogni giorno',
    recurrence_weekly: 'Ogni settimana',
    recurrence_monthly: 'Ogni mese',
    // ── Pagina Rapporto ──
    report_title: 'Diario',
    report_calendar_view: 'Vista Calendario',
    report_daily: 'Giornaliero',
    report_weekly: 'Settimanale',
    report_monthly: 'Mensile',
    report_custom: 'Rapporto Personalizzato',
    report_completed: 'Completati',
    report_total_tasks: 'Totale Attività',
    report_completion_rate: 'Tasso di Completamento',
    report_habit_tracking: 'Abitudini',
    report_checked: 'Fatto',
    report_unchecked: 'Da fare',
    report_quadrant_distribution: 'Quadrante Priorità',
    report_completion_trend: 'Trend di Completamento',
    report_activity: 'Attività',
    report_activity_records: 'Registro Attività',
    report_ai_diary_analysis: 'Analisi Diario AI',
    report_ai_diary_waiting: '{{companion}} aspetta la tua prima registrazione di oggi.',
    report_generate_diary: 'Visualizza l\'Osservazione di Oggi',
    report_generate_confirm: 'Puoi generare un\'osservazione solo una volta al giorno. Generarla ora?',
    report_generating: '{{companion}} sta scrivendo...',
    report_generating_variant_1: '{{companion}} sta riordinando con cura i momenti di oggi e scrivendo il tuo diario…',
    report_generating_variant_2: '{{companion}} sta trasformando i ricordi di oggi in parole. Dammi solo un attimo~',
    report_generating_variant_3: '{{companion}} sta organizzando l\'umore e il ritmo di oggi...',
    report_generating_variant_4: '{{companion}} ha ricevuto i record di oggi e sta scrivendo adesso...',
    report_generating_patience: 'La consegna degli appunti attraverso anni luce richiede tempo — attendi 1‑2 minuti',
    report_ai_diary_header: 'Diario AI di Oggi',
    report_coming_soon: 'In arrivo',
    report_weekly_coming_soon: 'Report settimanale in arrivo',
    report_monthly_coming_soon: 'Report mensile in arrivo',
    report_custom_coming_soon: 'Report personalizzato in arrivo',
    report_completed_tasks: 'Attività Completate',
    report_all_tasks: 'Tutte le Attività',
    report_no_tasks: 'Nessuna attività',
    report_close_detail: 'Chiudi dettaglio report',
    report_error_unknown: 'Errore sconosciuto',
    report_activity_category: 'Distribuzione Attività',
    report_view_diary_book: 'Libro di Diari',
    report_generate_button: 'Genera Diario',
    report_generate_success: 'Il diario di oggi e stato generato.',
    report_generate_already: 'Il diario e gia stato generato. Vai a vederlo nel Diario~',
    report_early_tip: 'Il diario può essere generato una sola volta. Torna dopo le 20:00.',
    report_early_tip_ok: 'Capito',
    report_back_diary_book: 'Diari',
    report_generate_plant: 'Genera Pianta',
    report_section_collapse: 'Comprimi',
    report_section_expand: 'Espandi',
    report_todo_section: 'Attività',
    report_upgrade_title: 'Passa a Pro',
    report_upgrade_desc: 'Il Diario AI è una funzione esclusiva di Pro. Aggiorna per sbloccare le voci giornaliere generate dall\'AI.',
    report_upgrade_btn: 'Ottieni Pro Ora',
    report_upgrade_later: 'Forse Dopo',
    report_teaser_unlock: '✨ Sblocca la storia completa di stasera →',
    report_swipe_hint: '← Scorri a sinistra per diario AI & note',
    report_my_diary: 'Il Mio Diario',
    report_diary_placeholder: 'Scrivi l\'umore e le sensazioni di oggi…',
    report_diary_empty: 'Nessuna nota…',
    report_save: 'Salva',
    report_habit_checkin: 'Check-in Abitudini',
    report_goal_progress: 'Progresso Obiettivi',
    report_goal_done_today: 'Fatto oggi',
    report_goal_not_today: 'Non oggi',
    report_recurring_tasks: 'Attività Ricorrenti',
    report_task_priority: 'Priorità Attività',
    report_root_section_title: 'Crescita delle Radici',
    report_root_section_subtitle: 'Le attività diurne continuano ad allungare le tue radici.',
    report_root_empty_title: 'Il terreno sta accumulando energia',
    report_root_empty: 'Nessuna radice visibile per ora. Completa prima un\'attività di almeno 5 minuti.',
    plant_section_generated_badge: 'Generata oggi',
    plant_generate_button: 'Genera la Pianta di Oggi',
    plant_generating: 'Le tue radici si stanno condensando nella pianta di oggi...',
    plant_generate_try_after_20: 'Riprova dopo le 20:00',
    plant_generate_done_button: 'Generata Oggi',
    plant_generate_locked_hint: 'Le radici stanno ancora crescendo. Torna dopo le 20:00.',
    plant_generate_locked_with_diary_hint: 'Le radici stanno ancora crescendo. Dopo le 20:00 puoi generare sia la pianta che il diario di oggi.',
    plant_early_activities: 'Oggi hai registrato {{count}} attività',
    plant_generate_ready_hint: 'Le tue radici sono pronte. Ora puoi generare la pianta di oggi.',
    plant_generate_confirm: 'Generare ora la pianta di oggi? Per oggi questa azione è irreversibile.',
    plant_generate_success: 'La pianta di oggi è stata generata.',
    plant_generate_already: 'La pianta di oggi è già stata generata.',
    plant_generate_empty_day: 'Nessuna attività registrata oggi. Il terreno è in attesa.',
    plant_generate_empty_day_fallback: 'Non ci sono ancora attività valide per la generazione. Registra un momento e riprova stasera.',
    plant_generate_monthly_exhausted: 'Tutte le piante di questo tipo di radice sono già state generate questo mese. Il pool si azzera il mese prossimo.',
    plant_generate_failed: 'Generazione non riuscita. Riprova più tardi.',
    plant_reveal_title: 'Rivelazione della Pianta di Oggi',
    plant_reveal_subtitle: 'Le radici di oggi sono ora fissate in una pianta. Domani inizierà un nuovo ciclo di crescita.',
    plant_reveal_special_air: 'Oggi è una giornata leggera: la pianta conserva questo ritmo più arioso.',
    plant_reveal_special_entertainment: 'Oggi prevalgono svago e recupero, e la pianta riflette questa morbidezza.',
    plant_image_alt: 'Immagine della pianta di oggi',
    plant_image_missing: 'L\'illustrazione della pianta è in caricamento. Riprova tra poco.',
    plant_detail_title: 'Dettaglio Radice',
    plant_detail_activity: 'Attività',
    plant_detail_time_range: 'Fascia oraria',
    plant_detail_category: 'Categoria',
    plant_detail_duration: 'Durata',
    plant_detail_focus: 'Concentrazione',
    plant_focus_high: 'Alta concentrazione',
    plant_focus_medium: 'Concentrazione media',
    plant_direction_left_bottom: 'Sinistra',
    plant_direction_left_top: 'Centro-sinistra',
    plant_direction_top: 'Centro',
    plant_direction_right_top: 'Centro-destra',
    plant_direction_right_bottom: 'Destra',
    plant_canvas_reset: 'Reimposta',
    plant_category_work_study: 'Lavoro e Studio',
    plant_category_exercise: 'Esercizio',
    eco_sphere_mood_label: 'Umore',
    eco_sphere_activity_label: 'Attività',
    eco_sphere_empty_label: 'Presto',
    eco_sphere_diary_label: 'Diario',
    eco_sphere_mood_energy_title: "Energia dell'umore oggi",
    eco_sphere_no_mood_data: 'Nessun dato umore. Condividi come ti senti!',
    eco_sphere_no_activity_data: 'Nessun dato attività.',
    eco_sphere_night_hint: 'Questi dati saranno inclusi nel diario di stasera.',
    diary_nav_prev: 'Giorno precedente',
    diary_nav_next: 'Giorno successivo',
    diary_back_to_shelf: 'Indietro',
    diary_shelf_count: '{{count}} mesi raccolti',
    diary_days_count: '{{count}} giorni',
    diary_shelf_open_calendar: 'Seleziona data',
    diary_shelf_back_year: 'Torna all\'anno',
    diary_shelf_no_diary: 'Nessun diario per questa data',
    diary_shelf_open_date: 'Apri {{date}}',
    diary_shelf_search_hint: 'Scrivi numeri per trovare quel giorno, o parole per cercare nei tuoi ricordi～',
    diary_shelf_text_no_results: 'Nessun diario trovato',
    diary_shelf_text_results_count: '{{count}} trovati',
    diary_shelf_field_diary: 'diario',
    diary_shelf_field_observation: 'osservazione',
    diary_shelf_field_activity: 'attività',
    diary_shelf_field_mood: 'umore',
    diary_cover: 'Copertina diario',
    diary_cover_subtitle: 'Taccuino di compagnia',
    diary_back_cover: 'Retro copertina',
    diary_day_n: 'Giorno {{n}}',
    diary_double_tap_open: 'Doppio tap per aprire',
    diary_double_tap_zoom: 'Doppio tap per ingrandire',
    diary_star_count: '{{count}} stelle',
    diary_expanded_ai_observation: 'Note di osservazione AI',
    diary_expanded_ai_pending: 'L\'AI sta organizzando le note…',
    diary_expanded_ai_empty: 'Nessuna nota AI per ora',
    diary_expanded_today_after_8: 'Il diario di oggi sara generato dopo le 20:00',
    diary_expanded_no_diary: 'Nessun diario registrato',
    diary_expanded_activity: 'Distribuzione Attivita',
    diary_expanded_mood: 'Umore di Oggi',
    diary_expanded_my_diary: 'Il Mio Diario',
    diary_expanded_no_note: 'Nessuna nota lasciata…',
    plant_save_card: 'Salva Biglietto',
    plant_tap_to_flip: 'Tocca per girare',
    plant_card_diary_button: 'Genera Diario',
    // ── Pagina Autenticazione ──
    auth_welcome_back: 'Bentornato',
    auth_create_account: 'Crea Account',
    auth_login_subtitle: 'Accedi per sincronizzare i tuoi dati',
    auth_register_subtitle: 'Registrati per iniziare la sincronizzazione cloud',
    auth_account_label: 'Indirizzo email',
    auth_account_placeholder: 'Indirizzo email',
    auth_nickname_label: 'Nickname',
    auth_nickname_placeholder: 'Il tuo nickname (opzionale)',
    auth_password_label: 'Password',
    auth_password_placeholder: 'Password',
    auth_login_button: 'Accedi',
    auth_register_button: 'Registrati',
    auth_switch_to_register: 'Non hai un account? Registrati',
    auth_switch_to_login: 'Hai già un account? Accedi',
    auth_register_success: 'Un codice di verifica è stato inviato alla tua email. Inseriscilo qui sotto per completare la registrazione.',
    auth_otp_placeholder: 'Inserisci il codice a 6 cifre',
    auth_resend_code: 'Reinvia codice',
    auth_verify_button: 'Verifica',
    auth_error_rate_limit: 'Troppe richieste — riprova più tardi (limite email raggiunto)',
    auth_error_invalid_credentials: 'Email o password non valide',
    auth_error_user_exists: 'Questa email è già registrata',
    auth_error_password_short: 'La password deve essere di almeno 6 caratteri',
    auth_error_invalid_grant: 'Informazioni di accesso non valide o scadute',
    auth_error_invalid_account: 'Inserisci un indirizzo email valido',
    auth_error_generic: 'Si è verificato un errore: ',
    auth_select_avatar: 'Seleziona avatar',
    auth_close: 'Chiudi',
    auth_more: 'Altro',
    auth_change_avatar: 'Cambia avatar',
    avatar_alt: 'Avatar',
    auth_google_signin: 'Continua con Google',
    auth_apple_signin: 'Accedi con Apple',
    auth_or_divider: 'oppure',
    // ── Bolla Annotazione AI ──
    annotation_condensing: 'Cristallizzando…',
    annotation_condense: 'Cristallizza',
    annotation_condensed: 'Cristallizzato',
    annotation_hover_pause: 'In pausa al passaggio del mouse',
    annotation_suggestion_started: 'Iniziato ✓',
    // ── Scheda Stardust ──
    stardust_loading: 'Recupero memoria…',
    stardust_error_default: 'Caricamento memoria fallito — riprova più tardi',
    stardust_from: 'Da {{name}} · {{date}}',
    // ── Categorie Attività ──
    category_study: 'Studio',
    category_work: 'Lavoro',
    category_social: 'Sociale',
    category_life: 'Vita',
    category_entertainment: 'Intrattenimento',
    category_health: 'Salute',
    // ── Etichette umore ──
    mood_happy: 'Felice',
    mood_calm: 'Calmo',
    mood_focused: 'Concentrato',
    mood_satisfied: 'Soddisfatto',
    mood_tired: 'Stanco',
    mood_anxious: 'Ansioso',
    mood_bored: 'Annoiato',
    mood_down: 'Giù',
    // ── Selettore Lingua ──
    language_switch: 'Lingua',
    language_en: 'EN',
    language_zh: '中',
    weekday_short_sun: 'Dom',
    weekday_short_mon: 'Lun',
    weekday_short_tue: 'Mar',
    weekday_short_wed: 'Mer',
    weekday_short_thu: 'Gio',
    weekday_short_fri: 'Ven',
    weekday_short_sat: 'Sab',
    // ── Pagina Crescita ──
    nav_growth: 'Crescita',
    growth_title: 'Crescita',
    growth_daily_goal_title: 'Obiettivo di Vita',
    growth_daily_goal_subtitle: 'Scrivere il tuo obiettivo ogni giorno aumenta di 10 volte la probabilità di raggiungerlo',
    growth_daily_goal_placeholder: 'Scrivi il tuo obiettivo più importante...',
    growth_daily_goal_confirm: 'Conferma',
    growth_daily_goal_disable: 'Non mostrare più',
    growth_daily_goal_enable: 'Promemoria obiettivo giornaliero',
    growth_life_goal_title: 'Gestione Obiettivo di Vita',
    growth_life_goal_desc: 'Sincronizzato in entrambe le direzioni con il Profilo, per mantenere visibile la direzione a lungo termine.',
    growth_life_goal_placeholder: 'Scrivi la direzione che vuoi mantenere nel lungo periodo...',
    growth_life_goal_sync_hint: 'Sincronizzato con "Profilo > Obiettivo di vita"',
    growth_life_goal_save: 'Salva',
    growth_life_goal_saving: 'Salvataggio...',
    growth_life_goal_saved: 'Sincronizzato nel profilo',
    growth_life_goal_save_failed: 'Sincronizzazione non riuscita, riprova',
    growth_life_goal_no_changes: 'Nessuna modifica da salvare',
    growth_bottle_section: 'Abitudini / Obiettivi',
    growth_bottle_section_hint: 'Prepara una bottiglia nutriente per la tua pianta',
    growth_add_bottle: 'Aggiungi Bottiglia',
    growth_add_bottle_modal_title: 'Crea una Nuova Bottiglia Nutriente',
    growth_bottle_name: 'Nome',
    growth_bottle_name_placeholder: 'Es: Leggere 30 min al giorno',
    growth_bottle_type: 'Tipo',
    growth_bottle_type_habit: 'Abitudine',
    growth_bottle_type_goal: 'Obiettivo',
    growth_bottle_max_reached: 'Massimo 10 bottiglie raggiunto',
    growth_bottle_achieved: 'Raggiunto',
    growth_bottle_irrigate_hint: 'Può essere trasformato in nutriente per innaffiare la pianta',
    growth_bottle_irrigate: 'Innaffia Pianta',
    growth_bottle_irrigated: 'Pianta Innaffiata',
    growth_bottle_goal_confirm: 'Hai raggiunto questo obiettivo?',
    growth_bottle_goal_yes: 'Sì',
    growth_bottle_goal_no: 'Non ancora',
    growth_bottle_round: 'Round {{round}}',
    growth_bottle_stars: '{{stars}}/21',
    growth_todo_section: 'Attivita recenti',
    growth_todo_add: 'Aggiungi Attività',
    growth_todo_title_placeholder: 'Titolo attività...',
    growth_todo_due_date: 'Scadenza',
    growth_todo_priority: 'Priorità',
    growth_todo_priority_high: 'Alta',
    growth_todo_priority_medium: 'Media',
    growth_todo_priority_low: 'Bassa',
    growth_todo_link_bottle: 'Collega a Bottiglia',
    growth_todo_none: 'Nessuno',
    growth_todo_empty: 'Nessuna attività',
    growth_todo_title_required: 'Inserisci un titolo',
    growth_todo_complete: 'Completa attività',
    growth_focus_title: 'Modalità Focus',
    growth_focus_start: 'Inizia',
    growth_focus_end: 'Fine',
    growth_focus_end_confirm: 'Terminare la sessione di focus?',
    growth_focus_summary: 'Durata focus: {{duration}}',
    growth_focus_set_duration: 'Imposta Durata',
    growth_focus_counting_up: 'Conteggio in salita',
    growth_focus_resting: 'Fai una pausa',
    growth_focus_skip_rest: 'Salta pausa',
    todo_decompose_btn: 'Passo dopo passo',
    todo_decompose_regenerate_btn: 'Scomponi di nuovo',
    todo_decompose_loading: 'Scomposizione...',
    todo_decompose_error: 'Errore, riprova',
    todo_decompose_empty: 'Nessun passo utile, prova a riformulare',
    todo_decompose_steps_label: 'Passi',
    todo_decompose_min: 'min',
    todo_sequential_focus: 'Focus Sequenziale',
    growth_habit_todo_prompt: 'Creare attività giornaliera automatica?',
    growth_habit_todo_confirm: 'Aggiungere "{{name}}" come attività ricorrente giornaliera?',
    growth_habit_todo_dismiss: 'Salta',
    growth_bottle_create_todo: 'Crea Attività',
    growth_todo_recurrence: 'Ripeti',
    growth_todo_recurrence_once: 'Una volta',
    growth_todo_recurrence_daily: 'Ogni giorno',
    growth_todo_recurrence_weekly: 'Ogni settimana',
    growth_todo_due_datetime: 'Data e Ora Scadenza',
    growth_todo_start: 'Inizia',
    growth_todo_weekly_days: 'Seleziona Giorni',
    growth_todo_quick_add_placeholder: 'Aggiungi attività, Invio per salvare...',
    todo_due_badge_today: 'Oggi',
    todo_due_badge_tomorrow: 'Domani',
    todo_due_badge_overdue: 'Scaduto',
    todo_sort_smart: 'Ord. smart',
    todo_sort_manual: 'Manuale',
    growth_bottle_name_duplicate: 'Esiste già una bottiglia con questo nome',
    growth_bottle_todo_prompt: 'Creare un\'attività per "{{name}}"?',
    growth_bottle_open_detail: 'Apri dettagli di "{{name}}"',
    growth_bottle_stats_last7: 'Check-in (7g)',
    growth_bottle_stats_streak_current: 'Serie attuale',
    growth_bottle_stats_streak_best: 'Serie migliore',
    growth_bottle_delete: 'Elimina bottiglia',
    growth_bottle_delete_confirm: 'Eliminare "{{name}}"?',
    growth_bottle_sync_pending: 'Sincronizzazione in corso',
    growth_bottle_sync_failed: 'Sincronizzazione non riuscita',
    // ── Pagina Profilo ──
    profile_title: 'Profilo',
    profile_streak: 'Serra',
    profile_weekly_login_hint: '{{days}} giorni questa sett.',
    profile_today_activities: 'Oggi',
    profile_today_activities_hint: '{{count}} momenti oggi',
    profile_completed_goals: 'Obiettivi',
    profile_completed_goals_hint: 'In fioritura',
    profile_ai_mode: 'Compagno AI',
    profile_ai_mode_desc: "Quando e attivo, l'AI invia promemoria di compagnia basati sui tuoi appunti.",
    profile_ai_companion_select: 'Scegli compagno',
    profile_ai_mode_van_subtitle: 'Guarigione Emotiva',
    profile_ai_mode_agnes_subtitle: 'Guida Lucida',
    profile_ai_mode_zep_subtitle: 'Verita Quotidiana',
    profile_ai_mode_momo_subtitle: 'Catalizzatore di Ordine',
    profile_free: 'Gratuito',
    profile_annotation_drop: 'Frequenza compagnia',
    profile_drop_low: 'Bassa',
    profile_drop_medium: 'Media',
    profile_drop_high: 'Alta',
    profile_daily_goal: 'Obiettivo Giornaliero',
    profile_daily_goal_desc: 'Mostra il popup degli obiettivi entrando nella pagina Crescita',
    profile_long_term_profile: 'Attiva Memoria Personale',
    profile_long_term_profile_desc: 'Quando e attiva, AI ricorda i vostri momenti e ti accompagna in modo sempre piu personale.',
    profile_long_term_profile_saved: 'Impostazione memoria personale aggiornata',
    profile_long_term_profile_save_failed: 'Aggiornamento memoria personale non riuscito',
    profile_routine_title: 'La Mia Routine',
    profile_routine_desc: 'Imposta orari di sveglia, sonno e pasti per avere promemoria piu adatti al tuo ritmo.',
    profile_routine_time_section: 'Orari Giornalieri',
    profile_routine_save: 'Salva',
    profile_routine_saving: 'Salvataggio...',
    profile_routine_no_changes: 'Nessuna modifica alla routine',
    profile_routine_saved: 'Routine salvata',
    profile_routine_save_failed: 'Salvataggio routine non riuscito, riprova',
    profile_ai_memory_locked_title: 'Memoria Personale AI (Pro)',
    profile_ai_memory_locked_desc: 'Passa a Pro per attivare la memoria che conserva preferenze e momenti nel tempo.',
    profile_user_profile_title: 'Memoria Personale AI',
    profile_user_profile_desc: 'Solo Pro. Salva preferenze e stile di comunicazione per un accompagnamento AI piu personale.',
    profile_user_profile_tab_schedule: 'Routine',
    profile_user_profile_tab_personalization: 'Personalizzazione',
    profile_user_profile_tab_anniversaries: 'I miei anniversari',
    profile_user_profile_primary_use: 'Uso principale',
    profile_user_profile_select_placeholder: 'Seleziona',
    profile_user_profile_use_life_record: 'Registrare la vita',
    profile_user_profile_use_organize_thoughts: 'Organizzare i pensieri',
    profile_user_profile_use_emotion_management: 'Gestione emozioni',
    profile_user_profile_use_habit_building: 'Costruire abitudini',
    profile_user_profile_wake_time: 'Sveglia',
    profile_user_profile_sleep_time: 'Sonno',
    profile_user_profile_breakfast: 'Colazione',
    profile_user_profile_lunch: 'Pranzo',
    profile_user_profile_dinner: 'Cena',
    profile_user_profile_current_goal: 'Obiettivo attuale',
    profile_user_profile_current_goal_placeholder: 'Cosa vuoi portare avanti in questo periodo?',
    profile_user_profile_life_goal: 'Obiettivo di vita',
    profile_user_profile_life_goal_placeholder: 'Opzionale: scrivi un obiettivo piu a lungo termine',
    profile_user_profile_personalization: 'Personalizzazione',
    profile_user_profile_personalization_placeholder: 'Scrivi liberamente cosa ti piace/non ti piace, preferenze relazionali e stile di comunicazione.',
    profile_user_profile_anniversaries: 'Anniversari visibili',
    profile_user_profile_my_anniversaries: 'I miei anniversari',
    profile_user_profile_anniversary_source_user: 'Aggiunto da me',
    profile_user_profile_anniversary_source_ai: 'Rilevato da AI',
    profile_user_profile_add_anniversary: 'Aggiungi',
    profile_user_profile_anniversary_empty: 'Nessun anniversario',
    profile_user_profile_anni_label_placeholder: 'Dai un nome alla data',
    profile_user_profile_anni_repeat: 'Ripeti ogni anno',
    profile_user_profile_remove_anniversary: 'Rimuovi anniversario',
    profile_user_profile_anni_limit: 'Puoi aggiungere fino a 10 anniversari',
    profile_user_profile_save: 'Salva memoria personale',
    profile_user_profile_saving: 'Salvataggio...',
    profile_user_profile_no_changes: 'Nessuna modifica da salvare',
    profile_user_profile_partial_anniversary: 'Ogni anniversario richiede nome e data',
    profile_user_profile_saved: 'Memoria personale salvata. Ti capiro sempre meglio nel tempo.',
    profile_user_profile_save_failed: 'Salvataggio non riuscito, riprova',
    profile_snapshot_title: 'Snapshot Profilo',
    profile_snapshot_desc_enabled: 'Profilo a lungo termine attivo. I suggerimenti possono usare questi segnali.',
    profile_snapshot_desc_disabled: 'Profilo a lungo termine disattivo. I dati sotto servono solo per modifica locale.',
    profile_snapshot_meal_title: 'Orari pasti di riferimento',
    profile_snapshot_anniversary_title: 'Anniversari imminenti',
    profile_snapshot_recall_title: 'Ultimo momento richiamabile',
    profile_snapshot_empty: 'Nessuno',
    profile_membership: 'Abbonamento',
    profile_upgrade: 'Passa a Pro · Sblocca tutto',
    profile_upgrade_trial: 'Prova gratuita Pro · Sblocca tutto',
    profile_upgrade_coming: 'Prossimamente',
    upgrade_back: 'Indietro',
    upgrade_title: 'Passa a Pro',
    upgrade_plan_label: 'Scegli piano',
    upgrade_plan_monthly: 'Mensile',
    upgrade_plan_annual: 'Annuale',
    upgrade_price_monthly: '$7.99 / mese',
    upgrade_price_annual: '$99.99 / anno',
    upgrade_price_monthly_note: 'Prezzo intro, poi $9.99',
    upgrade_price_annual_note: 'Valore migliore sul lungo periodo',
    upgrade_feature_label: 'Funzioni sbloccate',
    upgrade_payment_source: 'Canale pagamento attuale: {{source}}',
    upgrade_continue_button: 'Continua con {{price}}',
    upgrade_restore_button: 'Ripristina acquisto',
    upgrade_processing: 'Elaborazione...',
    upgrade_purchase_success: 'Acquisto riuscito. Pro e ora attivo.',
    upgrade_restore_success: 'Ripristino riuscito. Stato abbonamento aggiornato.',
    upgrade_error_iap_not_ready: 'Il plugin IAP non e ancora collegato su questo dispositivo. Completa il wiring nativo iOS e riprova.',
    upgrade_error_subscription_failed: 'Richiesta abbonamento non riuscita. Riprova piu tardi.',
    upgrade_error_activate_failed: 'Attivazione abbonamento non riuscita. Verifica l acquisto e riprova.',
    upgrade_error_restore_failed: 'Ripristino acquisto non riuscito. Riprova piu tardi.',
    upgrade_error_stripe_not_ready: 'Checkout Stripe non ancora collegato in questa build.',
    upgrade_error_stripe_not_supported: 'Ripristino non supportato per Stripe in questa build.',
    upgrade_error_generic: 'Operazione non riuscita. Riprova piu tardi.',
    membership_purchase_title: 'Sblocca una crescita senza limiti',
    membership_purchase_subtitle: 'Attiva Pro: i dati diventano insight concreti',
    membership_purchase_plan_monthly_name: 'Piano Mensile',
    membership_purchase_trial_name: 'Prova gratuita',
    membership_purchase_trial_desc: 'Prova Pro gratis per 7 giorni, annulla quando vuoi',
    membership_purchase_trial_period: '7 giorni',
    membership_purchase_plan_yearly_name: 'Piano Annuale',
    membership_purchase_plan_monthly_desc: 'Massima flessibilita, rinnovo mese per mese',
    membership_purchase_plan_yearly_desc: 'Offerta limitata, equivalente a 8.33/mese',
    membership_purchase_plan_yearly_tag: 'Risparmia 15%',
    membership_purchase_plan_period_month: 'mese',
    membership_purchase_plan_period_year: 'anno',
    membership_purchase_popular_badge: 'Piu scelto',
    membership_purchase_features_title: 'Vantaggi esclusivi Pro',
    membership_purchase_free_label: 'Utenti Free',
    membership_purchase_pro_label: 'Membri Pro',
    membership_purchase_ai_badge: 'Con AI',
    membership_purchase_ai_enhanced_badge: 'AI potenziata',
    membership_purchase_feat_all_roles_title: 'Tutti i ruoli AI',
    membership_purchase_feat_all_roles_desc: 'Sblocca tutte le personalita del companion',
    membership_purchase_feat_growth_title: 'Monitoraggio crescita profonda',
    membership_purchase_feat_growth_desc: 'Monitora in profondita progresso mentale e comportamentale',
    membership_purchase_feat_memory_title: 'Accompagnamento AI profondo',
    membership_purchase_feat_memory_desc: 'Tutti i ruoli disponibili, frequenza regolabile, memoria esclusiva',
    membership_purchase_feat_daily_title: 'Diario personalizzato della serra',
    membership_purchase_feat_daily_desc: 'Generato ogni giorno per registrare la tua crescita e il percorso emotivo',
    membership_purchase_feat_weekly_title: 'Penna magica — inserimento rapido',
    membership_purchase_feat_weekly_desc: 'Una frase estrae automaticamente attività, stati d\'animo e cose da fare',
    membership_purchase_feat_mood_ai_title: 'Riconoscimento AI potenziato',
    membership_purchase_feat_mood_ai_desc: 'I membri Pro usano l\'AI per classificare attività e stati d\'animo con maggiore precisione',
    membership_purchase_feat_star_ai_title: 'Associazione intelligente AI',
    membership_purchase_feat_star_ai_desc: 'I membri Pro usano l\'AI per l\'associazione automatica della bottiglia stelle con maggiore precisione',
    membership_purchase_feat_monthly_title: 'To-do a passaggi',
    membership_purchase_feat_monthly_desc: 'Trasforma grandi obiettivi in piccoli passi eseguibili per avanzare più facilmente',
    membership_purchase_feat_yearly_title: 'Monitoraggio crescita profonda: report settimanali/mensili/personalizzati (In arrivo)',
    membership_purchase_feat_yearly_desc: 'In arrivo, funzionalità in sviluppo attivo',
    membership_purchase_compare_all_roles_free: 'Disponibile il ruolo Van',
    membership_purchase_compare_all_roles_pro: 'Sblocca tutti e 4 i ruoli AI',
    membership_purchase_compare_growth_free: 'Osservazione crescita di base',
    membership_purchase_compare_growth_pro: 'Monitoraggio profondo con trend insight',
    membership_purchase_compare_mood_title: 'Classificazione umore attivita',
    membership_purchase_compare_mood_free: 'Categorie umore di base',
    membership_purchase_compare_mood_pro: 'Riconoscimento AI piu preciso e dettagliato',
    membership_purchase_compare_daily_free: 'Vista diario base',
    membership_purchase_compare_daily_pro: 'Diario personalizzato con contesto piu ricco',
    membership_purchase_compare_star_bottle_title: 'Associazione automatica bottiglia stelle',
    membership_purchase_compare_star_bottle_free: 'Associazione automatica a regole base',
    membership_purchase_compare_star_bottle_pro: 'Associazione intelligente AI piu accurata',
    membership_purchase_compare_todo_free: 'Note to-do di base',
    membership_purchase_compare_todo_pro: 'Scomposizione to-do passo per passo',
    membership_purchase_compare_report_free: 'Report giornaliero base',
    membership_purchase_compare_report_pro: 'Report settimanali/mensili/personalizzati (in sviluppo)',
    membership_purchase_cta: 'Passa a Pro',
    membership_purchase_footer_cancel_anytime: 'Annulla quando vuoi',
    membership_purchase_footer_secure_pay: 'Pagamento sicuro',
    profile_help: 'Aiuto e Supporto',
    profile_privacy: 'Privacy',
    profile_about: 'Informazioni',
    profile_change_password: 'Cambia Password',
    profile_set_password: 'Imposta Password',
    change_password_title_change: 'Cambia Password',
    change_password_title_set: 'Imposta una Password',
    change_password_hint: 'Dopo aver impostato una password, potrai accedere anche con email e password.',
    change_password_new_placeholder: 'Nuova password (min. 6 caratteri)',
    change_password_confirm_placeholder: 'Conferma nuova password',
    change_password_save: 'Salva',
    change_password_success: 'Password aggiornata',
    change_password_mismatch: 'Le password non coincidono',
    change_password_too_short: 'La password deve avere almeno 6 caratteri',
    change_password_error: 'Aggiornamento fallito, riprova',
    profile_region_settings: 'Impostazioni Area',
    profile_region_settings_desc: 'Usato per contesto festivita e meteo. Inserisci citta/area o usa la posizione attuale.',
    profile_region_current: 'Area attuale: {{value}}',
    profile_region_not_set: 'Non impostata',
    profile_region_placeholder: 'Inserisci citta o area, es. Shanghai / Milan',
    profile_region_use_current: 'Usa posizione attuale',
    profile_region_locating: 'Localizzazione...',
    profile_region_save: 'Salva',
    profile_region_saving: 'Salvataggio...',
    profile_region_not_found: 'Area non trovata. Prova con un nome piu specifico.',
    profile_region_country_fallback_hint: 'Nessuna area precisa trovata. Vuoi salvare il paese: {{value}}',
    profile_region_save_country: 'Salva paese',
    profile_region_save_error: 'Salvataggio area non riuscito. Riprova.',
    profile_region_locate_error: 'Localizzazione non riuscita. Controlla i permessi posizione.',
    profile_root_direction_settings: 'Impostazioni Direzione Radici',
    profile_root_direction_settings_desc: 'Scegli il tipo per ogni direzione. Le modifiche cambiano solo la visualizzazione, non il risultato finale.',
    profile_root_direction_reset: 'Ripristina',
    profile_root_direction_save: 'Salva',
    profile_root_direction_saving: 'Salvataggio...',
    profile_root_direction_duplicate_error: 'Le categorie di direzione non possono essere duplicate. Modifica e salva di nuovo.',
    profile_root_direction_save_error: 'Salvataggio non riuscito. Riprova.',
    profile_logout: 'Esci',
    profile_plus_only: 'Passa a Pro per sbloccare',
};

import { itExtra } from './it.extra';
const it = { ...itBase, ...itExtra };
export default it;
